/**
 * /audit-log — Link Admin cross-tenant audit log (LADM-AUDIT).
 *
 * Filter state is client-side (free-text, page counter) in the screen component —
 * no search-param schema needed. Route mounts the screen and provides the
 * breadcrumb label key.
 *
 * routeTree.gen.ts is generated on dev/build (gitignored) — do NOT hand-edit it.
 */
import { createFileRoute } from "@tanstack/react-router";
import { PlatformAuditLogScreen } from "../features/audit-log/PlatformAuditLogScreen";

export const Route = createFileRoute("/_auth/audit-log")({
  staticData: { breadcrumb: { labelKey: "nav.audit_log" } },
  component: PlatformAuditLogScreen,
});
